import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { NgChartsModule } from 'ng2-charts';
import { ChartData, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

// interface StatisticsDeliveryDTO {
//   totalDelivered: number;
//   inRange: number;
//   notInRange: number;
//   dmdc: number;
//   aperCDelivered: number;
// }

// interface StatisticsDTO {
//   waybillsTotali: number;
//   waybillsDMDC: number;
//   waybillsBigOrders: number;
//   parcelsTotali: number;
//   parcelsDMDC: number;
//   parcelsBigOrders: number;
//   parcelsMancanti: number;
//   parcelsBigOrdersPTV: number;
//   parcelsAperC: number;
// }

// interface StatisticsByDayDTO {
//   dataAffido: string;
//   affidati: number;
//   consegnati: number;
//   consegnatiInOrario: number;
//   inRange: number;
//   consegnatiInOrarioInRange: number;
//   percentualeConsegnati: number;
//   percentualeConsegnatiInOrario: number;
//   percentualeAffidatiConsegnatiInOrario: number;
//   percentualeConsegnatiInRange: number;
//   percentualeAffidatiConsegnatiInRange: number;
//   percentualeAffidatiConsegnatiInOrarioInRange: number;
//   percentualeConsegnatiInOrarioInRange: number;
// }

export interface StatisticsByCarrierDTO {
  warehouseName: string;
  carrierName: string;
  affidati: number;
  consegnati: number;
  consegnatiInOrario: number;
  inRange: number;
  consegnatiInOrarioInRange: number;
  percentualeConsegnati: number;
  percentualeConsegnatiInOrario: number;
  percentualeAffidatiConsegnatiInOrario: number;
  percentualeConsegnatiInRange: number;
  percentualeAffidatiConsegnatiInRange: number;
  percentualeAffidatiConsegnatiInOrarioInRange: number;
  percentualeConsegnatiInOrarioInRange: number;
}

export interface StatisticsByDayDTO {
  dataAffido: string;
  affidatiTot: number;
  consegnatiTot: number;
  consegnatiInOrarioTot: number;
  inRangeTot: number;
  consegnatiInOrarioInRangeTot: number;
  percConsegnatiTot: number;
  percConsegnatiInOrarioTot: number;
  percAffidatiConsegnatiInOrarioTot: number;
  percConsegnatiInRangeTot: number;
  percAffidatiConsegnatiInRangeTot: number;
  percAffidatiConsegnatiInOrarioInRangeTot: number;
  percConsegnatiInOrarioInRangeTot: number;
  carriers: StatisticsByCarrierDTO[];
}


interface Dealer {
  dealerCode: string | null;
  dealerName: string | null;
  dealerOperatingAddressCity: string | null;
  count?: number;
}

interface Warehouse {
  warehouseCode: string;
  warehouseName?: string;
}

interface Region {
  regionCode: string;
  regionName?: string;
}

interface Client {
  clientCode: string;
  clientName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

@Component({
  selector: 'app-statistics-ope-by-day',
  standalone: true,
  templateUrl: './statistics-ope-by-day.component.html',
  styleUrls: ['./statistics-ope-by-day.component.css'],
  imports: [FormsModule, CommonModule, TranslateModule, NgChartsModule, NgMultiSelectDropDownModule]
})
export class StatisticsOpeByDayComponent implements OnInit {

  stats?: StatisticsByDayDTO[];
  loading = false;
  error = '';
  warning = '';

  dateBefore26: boolean = false;

  expandedDay: any = null;

  // Filtri selezionati
  dateEnd: string = new Date().toISOString().split('T')[0];

  // Data inizio = 1° giorno del mese precedente
  dateStart: string = (() => {
    const today = new Date();
    const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return this.formatDateLocal(firstDayPrevMonth);
  })();
  
  scheduleType: string = '';

  scheduleIsNight: string = '';

  scheduleMethod: string = '';

  showJustifyParcels: boolean = true; 

  chartAffidatiData: ChartData<'bar' | 'line'> | undefined;
  chartConsegnatiData: ChartData<'bar' | 'line'>  | undefined;
  chartOptions: ChartOptions | undefined;   public ChartDataLabels = ChartDataLabels;   
  sortState = { active: '', direction: '' };

  filteredBrands: Brand[] = [];
  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];
  
  dropdownSettingsBrand: IDropdownSettings = {};
  dropdownSettingsClient: IDropdownSettings = {};

  selectedToggleTotal: string = 'totale_affidati';
  selectedToggleCertification: string = 'on_time'
   // Sistema di paginazione (copiato da dealers-list)
   pageIndex = 0;
   pageSize = 10; // Valore di default, verrà sovrascritto nel constructor
   totalItems = 0;
   private readonly PAGE_SIZE_KEY = 'statistics-by-day-page-size';
  constructor(private http: HttpClient) {
    this.pageSize = this.getStoredPageSize(); // Inizializza il pageSize nel constructor
  }

  private getStoredPageSize(): number {
    const stored = localStorage.getItem(this.PAGE_SIZE_KEY);
    return stored ? parseInt(stored, 10) : 10; // Default a 10 se non trovato
  }

  private savePageSize(size: number): void {
    localStorage.setItem(this.PAGE_SIZE_KEY, size.toString());
  }  

  private formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  ngOnInit(): void {
    this.warning = 'Selezionare almeno un cliente o un marchio per visualizzare le statistiche.';

    this.sortState = { active: 'dataAffido', direction: 'desc' };

    this.confrontaDate();

    const stored = localStorage.getItem('userFunctions');
    if(stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients; 

      this.filteredClients = this.clientsBrands.map(cb => ({
        clientCode: cb.clientCode,
        clientName: cb.clientName,
      }))
      .sort((a, b) => {
        if (!a.clientName && !b.clientName) return 0;       
        if (!a.clientName) return 1;                        
        if (!b.clientName) return -1;                       
        return a.clientName.localeCompare(b.clientName);   
      });

      const allBrands: Brand[] = this.clientsBrands.flatMap(cb =>
        cb.brands.map(b => ({
          brandCode: b.brandCode,
          brandName: b.brandName,
        }))
      ).sort((a, b) => {
        if (!a.brandName && !b.brandName) return 0;       
        if (!a.brandName) return 1;                        
        if (!b.brandName) return -1;                       
        return a.brandName.localeCompare(b.brandName);   
      });

      this.filteredBrands = Array.from(
        new Map(allBrands.map(b => [b.brandCode, b])).values()
      );

      this.dropdownSettingsBrand = {
        singleSelection: false,
        idField: 'brandCode',
        textField: 'brandName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true
      };
      this.dropdownSettingsClient = {
        singleSelection: false,
        idField: 'clientCode',
        textField: 'clientName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true
      };
  
      //this.fetchStatistics();
    }
  }

  onClientsChange(): void {
    this.getIntersectionClientsBrands();
  }

  getIntersectionClientsBrands() : void {
    if (!this.selectedClients || this.selectedClients.length === 0) {
      // Nessun client selezionato → mostro tutti i brands
      this.filteredBrands = Array.from(
        new Map(
          this.clientsBrands
            .flatMap(cb => cb.brands)
            .map(b => [b.brandCode, b])
        ).values()
      );
      this.selectedBrands = []; // reset
      return;
    }

    // prendo i codici dei client selezionati
    const selectedCodes = this.selectedClients.map(c => c.clientCode);

    // ottengo i brands per ogni client selezionato
    const brandLists = selectedCodes.map(code => {
      const client = this.clientsBrands.find(cb => cb.clientCode === code);
      return client ? client.brands : [];
    });


    // calcolo l’intersezione tra tutte le liste
    const intersection = brandLists.reduce((acc, curr) => {
      return acc.filter(b =>
        curr.some(x => x.brandCode === b.brandCode)
      );
    });


    // aggiorno i brands disponibili
    this.filteredBrands = intersection;
    this.selectedBrands = []; // reset per evitare selezioni incoerenti
  }


  selectAllClients() {
    this.selectedClients = [...this.filteredClients];

    this.getIntersectionClientsBrands();
  }

  deselectAllClients() {
    this.selectedClients = [];

    this.getIntersectionClientsBrands();
  }

  selectAllBrands() {
    this.selectedBrands = [...this.filteredBrands];
  }

  deselectAllBrands() {
    this.selectedBrands = [];
  }

  confrontaDate(): void {
    this.dateBefore26 = false;
    
    const start = new Date(this.dateStart);
    const data = new Date(this.dateEnd);

    start.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    if (data <= start) {
      this.dateBefore26 = true;
    }
  }
  fetchStatistics(): void {
    if ((this.selectedClients && this.selectedClients.length > 0) ||
          (this.selectedBrands && this.selectedBrands.length > 0)) {
      this.loading = true;
      this.error = '';
      this.warning = '';
      this.stats = undefined;

      let clientsBrandsSelected: ClientsBrands[];
      if(this.filteredClients.length == 1) {
        this.selectedClients = [...this.filteredClients];
      }
      if (this.selectedClients.length > 0) {
        clientsBrandsSelected = this.selectedClients.map(sc => {
          // trovo il client originale da clientsBrands
          const originalClient = this.clientsBrands.find(cb => cb.clientCode === sc.clientCode);

          var filteredBrandsFromClient: Brand[] = [];
          if(this.selectedBrands.length > 0) {
            // brands effettivi = intersezione tra quelli del client e quelli selezionati
            filteredBrandsFromClient = (originalClient?.brands || []).filter(b =>
              this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
            );
          }
          else {
            filteredBrandsFromClient = this.filteredBrands;
          }

          return {
            clientCode: sc.clientCode,
            clientName: sc.clientName,
            brands: filteredBrandsFromClient
          } as ClientsBrands;
        });
      } else if (this.selectedBrands && this.selectedBrands.length > 0) {
        // nessun client selezionato, ma brand sì
        clientsBrandsSelected = this.clientsBrands
          .map(cb => {
            const matchingBrands = cb.brands.filter(b =>
              this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
            );
            if (matchingBrands.length > 0) {
              return {
                clientCode: cb.clientCode,
                clientName: cb.clientName,
                brands: matchingBrands
              } as ClientsBrands;
            }
            return null;
          })
          .filter(cb => cb !== null) as ClientsBrands[];

      } else {
        // né client né brand selezionati → ritorno tutto
        clientsBrandsSelected = this.clientsBrands;
      }
      
          const body = {
            clients: clientsBrandsSelected || undefined,
            dateStart: this.dateStart || undefined,
            dateEnd: this.dateEnd || undefined,
            scheduleType: this.scheduleType || undefined,
            scheduleIsNight: this.scheduleIsNight || undefined,
            scheduleMethod: this.scheduleMethod || undefined,
            showJustifyParcels: this.showJustifyParcels || undefined
          };
      
      this.http.post<StatisticsByDayDTO[]>(`${environment.apiUrl}/statistics/statisticsOpeByDay`, body)
        .subscribe({
          next: (data) => {
            this.stats = data;
            console.log("stats finali ", this.stats);
            this.applySortManual();
            this.updatePagination();
            this.loading = false;
          },
          error: (err) => {
            this.error = 'Errore nel caricamento delle statistiche.';
            this.loading = false;
          }
        });
      this.confrontaDate();
      this.setGraphics();
    } else {
      this.stats = undefined;
      this.warning = 'Selezionare almeno un cliente o un marchio per visualizzare le statistiche.';
    }
  }


  toggleExpand(stat: any) {
    if (this.expandedDay === stat) {
      this.expandedDay = null;
    } else {
      this.expandedDay = stat;
    }
  }


  resetFilters(): void {
    this.selectedBrands = [];
    this.selectedClients = [];
    this.dateEnd = new Date().toISOString().split('T')[0];
    // Data inizio = 1° giorno del mese precedente
    this.dateStart = (() => {
      const today = new Date();
      const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      return this.formatDateLocal(firstDayPrevMonth);
    })();
    this.scheduleType = '';
    this.scheduleIsNight = '';
    this.scheduleMethod = '';
    this.showJustifyParcels = true;
    this.fetchStatistics();
  }

  exportStatisticsToExcel(): void {
    if (this.stats != null && this.stats.length > 0) {
      const exportData = this.stats.map(s => ({
        'Data Affido': new Date(s.dataAffido).toLocaleDateString('it-IT'),
        'N Affidati': s.affidatiTot,
        'N Consegnati': s.consegnatiTot,
        '% Consegnati': Number((s.percConsegnatiTot ?? 0).toFixed(2)),
        'N On Time': s.consegnatiInOrarioTot,
        '% On Time (su totale affidati)': Number((s.percAffidatiConsegnatiInOrarioTot ?? 0).toFixed(2)),
        '% On Time (su totale consegnati)': Number((s.percConsegnatiInOrarioTot ?? 0).toFixed(2)),
        'N In Range': s.inRangeTot,
        '% In Range (su totale affidati)': Number((s.percAffidatiConsegnatiInRangeTot ?? 0).toFixed(2)),
        '% In Range (su totale consegnati)': Number((s.percConsegnatiInRangeTot ?? 0).toFixed(2)),
        'N On Time e In Range': s.consegnatiInOrarioInRangeTot,
        '% On Time e In Range (su totale affidati)': Number((s.percAffidatiConsegnatiInOrarioInRangeTot ?? 0).toFixed(2)),
        '% On Time e In Range (su totale consegnati)': Number((s.percConsegnatiInOrarioInRangeTot ?? 0).toFixed(2))
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = { Sheets: { 'Statistiche': worksheet }, SheetNames: ['Statistiche'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blobData = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

      FileSaver.saveAs(blobData, `statistiche_colli_consegne_effettive_${timestamp}.xlsx`);
    }
  }

  exportStatisticsCarriersToExcel(): void {
    if (this.stats != null && this.stats.length > 0) {
      const exportData = this.stats.flatMap(s => 
      s.carriers.map(c => ({
        'Vettore': c.carrierName,
        'Transit Point': c.warehouseName,
        'Data Affido': new Date(s.dataAffido).toLocaleDateString('it-IT'),
        'N Affidati': c.affidati,
        'N Consegnati': c.consegnati,
        '% Consegnati': Number((c.percentualeConsegnati ?? 0).toFixed(2)),
        'N On Time': c.consegnatiInOrario,
        '% On Time (su totale affidati)': Number((c.percentualeAffidatiConsegnatiInOrario ?? 0).toFixed(2)),
        '% On Time (su totale consegnati)': Number((c.percentualeConsegnatiInOrario ?? 0).toFixed(2)),
        'N In Range': c.inRange,
        '% In Range (su totale affidati)': Number((c.percentualeAffidatiConsegnatiInRange ?? 0).toFixed(2)),
        '% In Range (su totale consegnati)': Number((c.percentualeConsegnatiInRange ?? 0).toFixed(2)),
        'N On Time e In Range': c.consegnatiInOrarioInRange,
        '% On Time e In Range (su totale affidati)': Number((c.percentualeAffidatiConsegnatiInOrarioInRange ?? 0).toFixed(2)),
        '% On Time e In Range (su totale consegnati)': Number((c.percentualeConsegnatiInOrarioInRange ?? 0).toFixed(2))
      })));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = { Sheets: { 'Statistiche': worksheet }, SheetNames: ['Statistiche'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blobData = new Blob([excelBuffer], { type: 'application/octet-stream' });

      const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

      FileSaver.saveAs(blobData, `statistiche_colli_consegne_effettive_vettori_${timestamp}.xlsx`);
    }
  }


  setGraphics(): void {
    if (this.stats) {
      this.chartAffidatiData = {
        labels: this.stats.map(s => s.dataAffido),
        datasets: [
          {
            type: 'bar',
            label: 'Affidati',
            data: this.stats.map(s => s.affidatiTot),
            backgroundColor: '#A5C8FF',
          },
          {
            type: 'line',
            label: '% Consegnati',
            data: this.stats.map(s => s.percConsegnatiTot),
            borderColor: '#F28E2B',
            borderWidth: 2,
            yAxisID: 'y1',
            tension: 0.3,
            pointBackgroundColor: '#F28E2B'
          }
        ]
      };

      this.chartConsegnatiData = {
        labels: this.stats.map(s => s.dataAffido),
        datasets: [
          {
            type: 'bar',
            label: 'Consegnati',
            data: this.stats.map(s => s.consegnatiTot),
            backgroundColor: '#A5C8FF',
          },
          {
            type: 'line',
            label: '% In orario',
            data: this.stats.map(s => s.percConsegnatiInOrarioTot),
            borderColor: '#D62728',
            borderWidth: 2,
            yAxisID: 'y1',
            tension: 0.3,
            pointBackgroundColor: '#D62728'
          }
        ]
      };

      this.chartOptions = {
        responsive: true,
        plugins: {
          datalabels: {
            display: true,
            color: '#000',
            anchor: 'end',
            align: 'top',
            formatter: (value: number) => value.toFixed(0),
            font: { weight: 'bold' }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: 'Quantità' }
          },
          y1: {
            position: 'right',
            beginAtZero: true,
            max: 100,
            grid: { drawOnChartArea: false },
            title: { display: true, text: 'Percentuale' }
          }
        }
      };
    }
  }  setSort(column: string) {
    if (this.sortState.active === column) {
      this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.active = column;
      this.sortState.direction = 'asc';
    }
    this.applySortManual();
    this.pageIndex = 0; // Reset alla prima pagina quando si cambia ordinamento
    this.updatePagination(); // Aggiorna la paginazione
  }  
  
  applySortManual(): void {
    if (this.stats && this.sortState.active && this.sortState.direction) {
      const isAsc = this.sortState.direction === 'asc';
      this.stats = [...this.stats].sort((a, b) => {
        switch (this.sortState.active) {
          case 'dataAffido': return this.compare(a.dataAffido, b.dataAffido, isAsc);
          case 'affidatiTot': return this.compare(a.affidatiTot, b.affidatiTot, isAsc);
          case 'consegnatiTot': return this.compare(a.consegnatiTot, b.consegnatiTot, isAsc);
          case 'consegnatiInOrarioTot': return this.compare(a.consegnatiInOrarioTot, b.consegnatiInOrarioTot, isAsc);
          case 'inRangeTot': return this.compare(a.inRangeTot, b.inRangeTot, isAsc);
          case 'consegnatiInOrarioInRangeTot': return this.compare(a.consegnatiInOrarioInRangeTot, b.consegnatiInOrarioInRangeTot, isAsc);
          case 'percConsegnatiTot': return this.compare(a.percConsegnatiTot, b.percConsegnatiTot, isAsc);
          case 'percAffidatiConsegnatiInOrarioTot': return this.compare(a.percAffidatiConsegnatiInOrarioTot, b.percAffidatiConsegnatiInOrarioTot, isAsc);
          case 'percConsegnatiInOrarioTot': return this.compare(a.percConsegnatiInOrarioTot, b.percConsegnatiInOrarioTot, isAsc);
          case 'percConsegnatiInRangeTot': return this.compare(a.percConsegnatiInRangeTot, b.percConsegnatiInRangeTot, isAsc);
          case 'percAffidatiConsegnatiInRangeTot': return this.compare(a.percAffidatiConsegnatiInRangeTot, b.percAffidatiConsegnatiInRangeTot, isAsc);
          case 'percConsegnatiInOrarioInRangeTot': return this.compare(a.percConsegnatiInOrarioInRangeTot, b.percConsegnatiInOrarioInRangeTot, isAsc);
          case 'percAffidatiConsegnatiInOrarioInRangeTot': return this.compare(a.percAffidatiConsegnatiInOrarioInRangeTot, b.percAffidatiConsegnatiInOrarioInRangeTot, isAsc);
          default: return 0;
        }
      });
      this.updatePagination(); // Aggiorna la paginazione dopo il sort
    }
  }
  compare(a: string | number, b: string | number, isAsc: boolean): number {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b) * (isAsc ? 1 : -1);
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }  updatePagination(): void {
    this.totalItems = this.stats?.length || 0;
    // Assicura che pageIndex sia valido dopo l'aggiornamento
    const totalPages = this.getNumberOfPages();
    if (this.pageIndex >= totalPages && totalPages > 0) {
      this.pageIndex = totalPages - 1;
    }
  }
  getNumberOfPages(): number {
    return Math.ceil(this.totalItems / Number(this.pageSize)) || 1;
  }  setPageSize(size: number): void {
    this.pageSize = Number(size);
    this.savePageSize(this.pageSize);
    this.pageIndex = 0;
    this.updatePagination();
  }getPaginatedStats(): StatisticsByDayDTO[] {
    if (!this.stats || this.stats.length === 0) return [];
    
    const pageSize = Number(this.pageSize); // Assicura che sia un numero
    const startIndex = this.pageIndex * pageSize;
    const endIndex = Math.min(startIndex + pageSize, this.stats.length);
    
    const result = this.stats.slice(startIndex, endIndex);
    
    // Verifica che il risultato non superi mai pageSize
    if (result.length > pageSize) {
      return result.slice(0, pageSize); // Forza il limite
    }
    
    return result;
  }firstPage(): void {
    this.pageIndex = 0;
  }

  previousPage(): void {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  }  nextPage(): void {
    if (this.pageIndex < this.getNumberOfPages() - 1) {
      this.pageIndex++;
    }
  }
  lastPage(): void {
    const totalPages = this.getNumberOfPages();
    this.pageIndex = Math.max(totalPages - 1, 0);
  }

    // Funzioni per navigazione date
  decrementStartDate(): void {
    if (this.dateStart) {
      const date = new Date(this.dateStart);
      date.setDate(date.getDate() - 1);
      this.dateStart = date.toISOString().split('T')[0];
    }
  }

  incrementStartDate(): void {
    if (this.dateStart) {
      const date = new Date(this.dateStart);
      date.setDate(date.getDate() + 1);
      this.dateStart = date.toISOString().split('T')[0];
    }
  }

  decrementEndDate(): void {
    if (this.dateEnd) {
      const date = new Date(this.dateEnd);
      date.setDate(date.getDate() - 1);
      this.dateEnd = date.toISOString().split('T')[0];
    }
  }

  incrementEndDate(): void {
    if (this.dateEnd) {
      const date = new Date(this.dateEnd);
      date.setDate(date.getDate() + 1);
      this.dateEnd = date.toISOString().split('T')[0];
    }
  }

  onToggleTotal(selection: 'totale_affidati' | 'totale_consegnati') {
    this.selectedToggleTotal = selection;
    
  }

  onToggleCertification(selection: 'on_time' | 'in_range') {
    this.selectedToggleCertification = selection;

  }
}
